export default "__VITE_ASSET__BDNXHLk7__"